import { render } from "./ModalNewOrdine.vue?vue&type=template&id=18f26de8&scoped=true"
import script from "./ModalNewOrdine.vue?vue&type=script&lang=js"
export * from "./ModalNewOrdine.vue?vue&type=script&lang=js"

import "./ModalNewOrdine.vue?vue&type=style&index=0&id=18f26de8&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f26de8"]])

export default __exports__